export default {
  APP_ID: "paidplan_apply",
  APPURL: {
    INDEX: "/",
    SERVICE_MENU: "/service_menu",
    CONFIRM: "/confirm",
    ANSHIN_INFO: "/anshin_info",
    DISCOUNT_INFO: "/discount_info",
    DISCOUNT_APPLY: "/discount_apply",
    ZERO_COMPLETE: "/complete0",
    ERROR: "/error",
    NOTFOUND: "/404",
    SECRET: "/secret",
    OUTOFPERIODS: "/outofperiods",
  },
  ROUTENM: {
    INDEX: "Index",
    SERVICE_MENU: "ServiceMenu",
    CONFIRM: "Confirm",
    ANSHIN_INFO: "AnshinInfo",
    DISCOUNT_INFO: "DiscountInfo",
    DISCOUNT_APPLY: "DiscountApply",
    ZERO_COMPLETE: "Complete0",
    ERROR: "Error",
    NOTFOUND: "NotFound",
    SECRET: "Secret",
    OUTOFPERIODS: "OutOfPeriods",
  },
  API: {
    URL: {
      CSRF: "/sanctum/csrf-cookie", // GET  CSRFトークン取得
      SYS_STATUS: "/api/paidplan_apl/sys_status", // GET メンテナンス中確認API
      USER_AUTH: "/api/paidplan_apl/user_authenticate", // POST お客様情報確認・取得
      APL_INFO: "/api/paidplan_apl/application_info", // POST 有料申込み情報取得
      SELECT_MENU: "/api/paidplan_apl/select_menu", // POST 申込内容選択画面選択結果登録
      ORDER_DETAIL: "/api/paidplan_apl/order_detail", // POST 申込内容取得
      ABANDON: "/api/paidplan_apl/abandon", // POST 申込み中止
      CLEAR: "/api/paidplan_apl/clear", // POST 申込内容クリア
      MAKE_PAYMENT: "/api/paidplan_apl/make_payment", // POST 決済情報登録・決済URL取得
      RETRY_MAKE_PAYMENT: "/api/paidplan_apl/retry_make_payment", // POST メールアドレスを変更して決済情報登録・決済URL取得
      MAKE_PAYMENT0: "/api/paidplan_apl/make_payment0", // POST 0円決済情報登録
      ANSHIN_APPLY: "/api/paidplan_apl/anshin_apply", // POST 安心だもんプラン申込み
      CHECK_SIBLING: "/api/paidplan_apl/check_sibling", // POST 兄弟割入力用、児童存在確認
      DISCOUNT_APPLY: "/api/paidplan_apl/discount_apply", // POST 兄弟割申込み
    },
  },
  // ローディングアニメーション
  LOADING: {
    COLOR: "#fff",
    BOXCOLOR: "rgba(0, 0, 0, 0.2)",
  },
  // APIリターンコード
  RET_CD: {
    OK: "0",
    NG: "1",
  },
  API_ERRCD: {
    DATA_NOT_FOUND: "1020", // 該当レコードなし
    INSERR: "1030", // レコード作成失敗
    UPDERR: "1040", // レコード更新失敗
    PA_MAINTE: "3001", // メンテナンス中（夜間バッチ中で、経理DBの年度支払情報テーブルがない）
    PA_NO_SCHOOLACADEMICYEAR: "3002", // 有料申込み児童が属する学校の学校年度情報がない
    PA_INVALID_TOKEN: "3003", // 有料申込みトークン無効
    PA_INVALID_OPERATION: "3005", // 無効な操作
    PA_AUTHFAILED: "3101", // 児童マスターCに、タグ番号・電話番号に該当する有効なレコードがない
    PA_STATUS_OFF: "3004", // 有料受付停止中
    PA_STATUS_MAINTE: "3006", // 有料受付メンテ中
    PA_GET_GMO_URL_FAILED: "3201", // GMO決済URL取得失敗
  },
  ERRSCR_ERRCD: {
    MAINTE: 100,
    TAU_EXPIRED: 200,
    TAU_COMPLETED: 210,
  },
  PG_ERRCD: {
    BADEMAIL: "EZ1109008", // メール送信先アドレスの書式が不正です。
    MAILREQUIRED: "EZ1109001", // メール送信先アドレスが指定されていません。
  },
  FLAG: {
    ON: 1,
    OFF: 0,
  },
  HP_URL: "https://tsuitamon.jp/",
  // 有料申込み状況
  PA_STATUS: {
    NOT_APPLIED: 0, // 申込されていない。（＝申込み可）
    IN_PROGRESS: 1, // 申込み手続き中
    DONE: 2, // 契約済み
    OUT_OF_TERM: 3, // 今年度内無料 (申込不可)
  },
  // ----------------------------------------------
  // 学校オプション
  // 兄弟割対応
  DISCOUNT_KB: {
    NA: 0, // 非対応
    YES: 1, // 対応
  },
  // 安心だもんプラン対応
  ANSHIN_KB: {
    NA: 0, // 非対応
    PERSONAL: 1, // 個人支払い
    ASSIST: 2, // 補助
  },
  // ----------------------------------------------
  // 安心だもんプラン申込み状況
  ANSHIN_STATUS: {
    NA: 0, // 対象外
    NOT_APPLIED: 1, // 未契約（申込期間内）
    NOT_APPLICABLE: 2, // 未契約（申込期間外）
    IN_PROGRESS: 3, // 申込み手続き中（GMO遷移後）
    DONE: 4, // 契約済み
  },
  // 申込区分
  APPLY_KB: {
    NOT_ENTERED: 0, // 未入力
    YES: 1, // 申し込む
    NO: 2, // 申し込まない
  },
  // ----------------------------------------------
  // 有料申込みワーク
  SERVICE_MENU: {
    PAIDPLAN: 1, // 有料プラン
    ANSHIN: 2, // 安心だもんプランのみ
  },
  // ----------------------------------------------
  // 申込内容詳細
  CONFIRM_DETAIL_KB: {
    NOT_APPLY: 0, // 申込みなし
    APPLY: 1, // 申込あり
    CONTRACTED: 2, // 契約済み
    IN_PROGRESS: 3, // 支払手続中
  },
};
